<script>
export default {
  data() {
    return {
      allData: [],
      showActive: true,
      newItem: {},
      clients: [],
      fetchUrl: "",
      isEditing: false,
      isModalOpen: false
    };
  },
  methods: {
    getActive(object, activeFieldName) {
      return object.filter(element => {
        return element[activeFieldName]
      })
    },
    fetchData(url) {
      this.fetchUrl = url;
      this.$axios.get(url).then((response) => {
        this.data = response.data.filter(element=>{
        return element.active==this.showActive;});
        this.allData = response.data;
      });
    },
    fetchPostData(url, params) {
      this.fetchUrl = url;
      this.$axios.post(url, params).then((response) => {
        this.data = response.data.filter(element=>{
        return element.active==this.showActive;});
        this.allData = response.data;
      });
    },
    fetchClients() {
      this.$axios.get("api/Clients/GetAllClient").then((response) => {
        this.clients = this.getActive(response.data, 'active');
      });
    },
    addOrEditItem(addURL, editUrl, isGet,  callback = null) {
      let url = "";
      let message = "";

      if (this.isEditing) {
        message = "Registro actualizado con éxito";
        url = editUrl;
      } else {
        message = "Registro añadido con éxito";
        url = addURL;

        // Añadir active al añadir por algun motivo del backend. ¯\_(ツ)_/¯
        this.$set(this.newItem, "active", true);
      }

      this.$axios.post(url, this.newItem).then(() => {
        // After the first request has completed successfully...
        // it either calls a callback function or it fetches all the paginatedData
        if (callback) {
          callback();
        } else {
          if(isGet===true){
            this.fetchData(this.fetchUrl);
            this.isEditing = false;           
          }else{
            this.fetchPostData(this.fetchUrl, {
              lang: this.language
            });
          }
        }
        this.openAlert('success', message, null);

        this.isModalOpen = false;
      });
    },
    openCreateModal() {
      this.newItem = {};
      this.isEditing = false;
      this.isModalOpen = true;
    },
    openEditModal(item) {
      this.newItem = { ...item };
      this.isEditing = true;
      this.isModalOpen = true;
    },
     toggleActive(){
      this.showActive =! this.showActive
      this.data=this.allData.filter(element=>{
        return element.active==this.showActive;
      });
    }
  }
};
</script>